import { render, staticRenderFns } from "./BoardListFinancialLayout.vue?vue&type=template&id=3b7f9d2d&scoped=true&"
import script from "./BoardListFinancialLayout.vue?vue&type=script&lang=js&"
export * from "./BoardListFinancialLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7f9d2d",
  null
  
)

export default component.exports